<div class="step-content">
    <div class="step-header">
        <h2>Attestations</h2>
        <p class="">
          Please review and answer all of the questions below prior to signing.</p>
    </div>

    <form [formGroup]="questionsForm" class="attestations-form" *ngIf="questionsForm && !errorMessage">
   
          <!-- 15 Questions -->
  <div formArrayName="questions" class="question-set">

    <div *ngFor="let q of questions.controls; let i = index"
         [formGroupName]="i"
         class="question-group">

      <!-- Radio -->
      <app-radio 
      [ngClass] ="!q.get('response')?.value ? 'showAsterisk' : 'hideAsterisk'"
      [formGroup]="getQuestionGroup(i)"
        [options]="[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]"
        [label]="questionsConfig[i].text"
        [layout]="'horizontal'">
      </app-radio>

      <!-- Validation -->
      <div class="error-message"
           *ngIf="q.get('response')?.invalid && q.get('response')?.touched">
        This field is required
      </div>

      <!-- Conditional explanation (YES only – as you stated) -->
      <div *ngIf="q.get('response')?.value === 'yes'" class="explanationField">
        <textarea class="explanation-textarea" [formControl]="getExplanationControl(i)" placeholder="Enter explanation"
          rows="4">
        </textarea>
        <!-- Validation -->
         <div class="error-message" *ngIf="getExplanationControl(i)?.invalid && getExplanationControl(i)?.touched"><span
            *ngIf="getExplanationControl(i)?.errors?.['required']"> Explanation is required. </span><span
            *ngIf="getExplanationControl(i)?.errors?.['whitespace']"> Please enter a valid explanation (spaces are not allowed).
          </span></div>
      </div>

    </div>
  </div>

        <!-- Attestation Checkbox -->
        <div class="attestation-section">
            <h3 class="section-title">Attestation</h3>
            <label class="checkbox-option">
                <app-checkbox id="Attestation" layout='horizontal' class="attestcheckbox"  [for]="'Attestation-Input'"
                [ngClass]="{ 'checkboxColorChange': !confirmationCheckbox }"
                    [checkboxLabels]="[checkboxLabel]" [formGroup]="AttestationcheckForm"></app-checkbox>
            </label>
            <div class="error-message" *ngIf="confirmationCheckbox">
                You must certify to proceed
            </div>
        </div>
        <div class="verbiage-text">
         <p> By clicking the checkbox and typing my name below, I certify that all information provided by me in my 
          application is current, true, correct, accurate and complete to the best of my knowledge and belief, 
          and is furnished in good faith. I understand that these actions constitute my electronic signature 
          and is legally binding.</p>
      </div>

        <!-- Full Name -->
        <div class="form-group attestation-grid">
            <app-text-input [replaceDoubelQuotes]="true" class="attestfullName"
                    [for]="'fullname'" [placeholder] = "'Enter full name'" [label] = "'Full name'"
                    [ngClass] ="!fullNameControl.value ? 'showAsterisk' : 'hideAsterisk'"
                    [control]="fullNameControl" [maxLength]="50"  [fieldType]= "'Full Name'">
                </app-text-input>
                <div [formGroup]="messageGroup">
                <textarea   class="attestTextarea"             
                formControlName="message"                
                aria-label="Attestation statement"
                placeholder="Type attestation statement"
                rows="3">
            </textarea> 
        </div> 
        </div>
    </form>   
    <div class="error-msg" *ngIf="errorMessage">{{errorMessage}}</div> 
    <app-wizard-navigation [showBack]="true" [showNext]="true" (back)="onBack()" (next)="onNext()" (cancel)="onCancel()">
    </app-wizard-navigation>
</div>